<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '#shared/utils';
import { useVModel } from '@vueuse/core';

const props = defineProps<{
	class?: HTMLAttributes['class'];
	defaultValue?: string | number;
	modelValue?: string | number;
}>();

const emits = defineEmits<{
	(e: 'update:modelValue', payload: string | number): void;
}>();

const modelValue = useVModel(props, 'modelValue', emits, {
	passive: true,
	defaultValue: props.defaultValue,
});

// Ref per l'elemento textarea
const textareaRef = ref<HTMLTextAreaElement | null>(null);

// Funzione per ripristinare lo zoom quando il campo perde il focus
const handleBlur = () => {
	if (typeof window !== 'undefined' && window.visualViewport) {
		// Ripristina lo zoom a 1.0 dopo un breve delay per permettere al browser di completare il blur
		setTimeout(() => {
			if (window.visualViewport && window.visualViewport.scale !== 1) {
				// Forza il ripristino dello zoom
				document.body.style.zoom = '1';
				setTimeout(() => {
					document.body.style.zoom = '';
				}, 100);
			}
		}, 100);
	}
};

onMounted(() => {
	if (textareaRef.value) {
		textareaRef.value.addEventListener('blur', handleBlur);
	}
});

onUnmounted(() => {
	if (textareaRef.value) {
		textareaRef.value.removeEventListener('blur', handleBlur);
	}
});
</script>

<template>
	<textarea
		ref="textareaRef"
		v-model="modelValue"
		:class="
			cn(
				'flex min-h-20 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
				props.class,
			)
		"
	/>
</template>
